/** Typed service-layer error (wrap raw Postgrest / client errors at boundaries when useful). */
export class ServiceError extends Error {
  readonly code: string
  override readonly cause?: unknown

  constructor(message: string, code: string, cause?: unknown) {
    super(message)
    this.name = 'ServiceError'
    this.code = code
    this.cause = cause
  }
}

/** Throws `ServiceError` when Supabase returns an error or null data where a row is required. */
export function assertNoError<T>(data: T | null, error: { message: string } | null, code: string): T {
  if (error) throw new ServiceError(error.message, code, error)
  if (data === null) throw new ServiceError('No data returned', code)
  return data
}

export interface EmailConflictInfo {
  phone: string
  name: string | null
  course: string | null
}

/** Raised when an email is already owned by another active student. */
export class EmailConflictError extends Error {
  readonly code = 'EMAIL_CONFLICT'
  readonly conflict: EmailConflictInfo

  constructor(conflict: EmailConflictInfo) {
    super(`Email already linked to student ${conflict.phone}`)
    this.name = 'EmailConflictError'
    this.conflict = conflict
  }
}
